import React, { useState } from 'react';
import { useQuery } from '@apollo/client/react';
import './AddDriversToPool.scss';
import Modal from 'react-bootstrap/Modal';
import { Loading, Error, CustomButton } from '../../../_common';
import { useStoreContext } from '../../../App/StoreProvider';
import { GET_AVAILABLE_DRIVERS_FOR_JOB, GET_SELECTED_DRIVERS_FOR_JOB } from '../../../../graphql/client/queries';
import {
    GetAvailableDriversForJob,
    GetAvailableDriversForJob_getAvailableDriversForJob as AvailableDrivers,
    GetSelectedDriversForJob,
    GetSelectedDriversForJob_getSelectedDriversForJob as SelectedDrivers,
} from '../../../../types/schemaTypes';
import AddDriversToPoolOption from './AddDriversToPoolOption/AddDriversToPoolOption';
import {  ToastContainer, toast } from 'react-toastify';

interface AddDriversToPoolProps {
    proppantName?: string | undefined;
    lofa?: string | undefined;
    wellhead?: string | undefined;
    onClickBack: (isSplit?: boolean) => void;
    onClickSave: (driversList?: (number | null | undefined)[]) => void;
    show: boolean;
    jobId?: number;
    isDisabled: boolean;
    setRefetched: React.Dispatch<React.SetStateAction<boolean>>;
    refetched: boolean;
}

const AddDriversToPool = ({
    show,
    onClickBack,
    onClickSave,
    wellhead,
    jobId,
    isDisabled,
    setRefetched,
    refetched,
}: AddDriversToPoolProps): React.ReactElement => {
    const [state] = useStoreContext();
    const [isAssigning, setIsAssigning] = useState(false);
    const [firstElement, setFirstElement] = useState(-1);
    const [firstElementsIndex, setFirstElementsIndex] = useState(-1);
    const [availableDriversToMove, setAvailableDriversToMove] = useState<number[]>([]);
    const [selectedDriversToMove, setSelectedDriversToMove] = useState<number[]>([]);
    const [availableDriverSearchPhrase, setAvailableDriverSearchPhrase] = useState<string>('');
    const [selectedDriverSearchPhrase, setSelectedDriverSearchPhrase] = useState<string>('');

    const [availableDriversListState, setAvailableDriversListState] = useState<(number | null | undefined)[]>();
    const [selectedDriversListState, setSelectedDriversListState] = useState<(number | null | undefined)[]>();

    const [driverListReset, setDriverListReset] = useState<boolean>(true);
    const [prevCountOfSelectedDrivers, setPrevCountOfSelectedDrivers] = useState<number>();
    const [prevCountOfAvailableDrivers, setPrevCountOfAvailableDrivers] = useState<number>();

    const {
        loading: availableDriversLoading,
        error: availableDriversError,
        data: availableDriversData,
        refetch: refetchAvailableDrivers,
    } = useQuery<GetAvailableDriversForJob>(GET_AVAILABLE_DRIVERS_FOR_JOB, {
        variables: { jobId },
        fetchPolicy: 'no-cache',
    });

    const {
        loading: selectedDriversLoading,
        error: selectedDriversError,
        data: selectedDriversData,
        refetch: refetchSelectedDrivers,
    } = useQuery<GetSelectedDriversForJob>(GET_SELECTED_DRIVERS_FOR_JOB, {
        variables: { jobId },
        fetchPolicy: 'no-cache',
    });

    if (refetched) {
        refetchSelectedDrivers();
        refetchAvailableDrivers();
        setRefetched(false);
    }

    const selectedDrivers: (SelectedDrivers | null)[] | null | undefined =
        selectedDriversData && selectedDriversData.getSelectedDriversForJob;
    const availableDrivers: (AvailableDrivers | null)[] | null | undefined =
        availableDriversData && availableDriversData.getAvailableDriversForJob;

    if (availableDriversLoading || selectedDriversLoading) {
        return <Loading />;
    }

    if (availableDriversError) {
        return <Error error={availableDriversError} />;
    }

    if (selectedDriversError) {
        return <Error error={selectedDriversError} />;
    }

    let filteredAvailableDrivers: (AvailableDrivers | null)[] | null | undefined;
    let filteredAvailableDrivers1: (AvailableDrivers | null)[] | null | undefined =[];
    let filteredAvailableDrivers2: (AvailableDrivers | null)[] | null | undefined =[];

    let filteredSelectedDrivers: (SelectedDrivers | null)[] | null | undefined;
    let filteredSelectedDrivers1: (SelectedDrivers | null)[] | null | undefined =[];
    let filteredSelectedDrivers2: (SelectedDrivers | null)[] | null | undefined =[];

    let selectedDriversList: (number | null | undefined)[] | undefined = [];
    let availableDriversList: (number | null | undefined)[] | undefined = [];

    const initSelectedDriverIds: (number | null | undefined)[] = [];
    const initAvailableDriverIds: (number | null | undefined)[] = [];

    selectedDrivers?.map(driver => {
        initSelectedDriverIds?.push(driver?.driverId);
    });
    availableDrivers?.map(driver => {
        initAvailableDriverIds?.push(driver?.driverId);
    });

    if (typeof prevCountOfSelectedDrivers === 'undefined' || typeof prevCountOfAvailableDrivers === 'undefined') {
        setPrevCountOfSelectedDrivers(initSelectedDriverIds.length);
        setPrevCountOfAvailableDrivers(initAvailableDriverIds.length);
    } else if (
        prevCountOfAvailableDrivers !== initAvailableDriverIds.length &&
        prevCountOfSelectedDrivers !== initSelectedDriverIds.length
    ) {
        setDriverListReset(true);
    }

    if (
        typeof availableDriversListState === 'undefined' ||
        typeof selectedDriversListState === 'undefined' ||
        driverListReset
    ) {
        availableDriversList = initAvailableDriverIds;
        setAvailableDriversListState(availableDriversList);
        setPrevCountOfAvailableDrivers(initAvailableDriverIds.length);

        selectedDriversList = initSelectedDriverIds;
        setSelectedDriversListState(selectedDriversList);
        setPrevCountOfSelectedDrivers(initSelectedDriverIds.length);

        setDriverListReset(false);
    } else {
        availableDriversList = availableDriversListState;
        selectedDriversList = selectedDriversListState;
    }

    // Filter Avavilable Drivers
    filteredAvailableDrivers1 =
        availableDrivers &&
        availableDrivers.filter(driver => {
            return driver && availableDriversList?.includes(driver?.driverId);
        });
    filteredAvailableDrivers2 =
        selectedDrivers &&
        selectedDrivers.filter(driver => {
            return driver && !selectedDriversList?.includes(driver?.driverId);
        });
    if (filteredAvailableDrivers2)
        filteredAvailableDrivers = filteredAvailableDrivers1?.concat(filteredAvailableDrivers2);

    // Filter Selected Drivers
    filteredSelectedDrivers1 =
        selectedDrivers &&
        selectedDrivers.filter(driver => {
            return driver && selectedDriversList?.includes(driver?.driverId);
        });
    filteredSelectedDrivers2 =
        availableDrivers &&
        availableDrivers.filter(driver => {
            return driver && !availableDriversList?.includes(driver?.driverId);
        });
    if (filteredSelectedDrivers2) filteredSelectedDrivers = filteredSelectedDrivers1?.concat(filteredSelectedDrivers2);

    // Available Drivers Search Filter
    if (availableDriverSearchPhrase && availableDriverSearchPhrase.length > 0) {
        filteredAvailableDrivers =
            filteredAvailableDrivers &&
            filteredAvailableDrivers.filter(driver => {
                return (
                    (driver && driver.name?.toLowerCase().includes(availableDriverSearchPhrase.toLowerCase())) ||
                    (driver && driver.companyName?.toLowerCase().includes(availableDriverSearchPhrase.toLowerCase()))
                );
            });
    }
    // Selected Drivers Search Filtering
    if (selectedDriverSearchPhrase && selectedDriverSearchPhrase.length > 0) {
        filteredSelectedDrivers =
            filteredSelectedDrivers &&
            filteredSelectedDrivers.filter(driver => {
                return (
                    (driver && driver.name?.toLowerCase().includes(selectedDriverSearchPhrase.toLowerCase())) ||
                    (driver && driver.companyName?.toLowerCase().includes(selectedDriverSearchPhrase.toLowerCase()))
                );
            });
    }

    const title = wellhead ? wellhead : '';

    const onClickHandler = (event, index: number, id: number, isListTypeSelected: boolean) => {
        let temp: number[];
        if (isListTypeSelected) temp = selectedDriversToMove;
        else temp = availableDriversToMove;

        if (
            firstElement !== -1 &&
            firstElementsIndex !== -1 &&
            firstElement !== id &&
            event.ctrlKey &&
            event.shiftKey
        ) {
            let next =
                index > firstElementsIndex
                    ? document.getElementById(firstElement.toString())?.nextElementSibling
                    : document.getElementById(firstElement.toString())?.previousElementSibling;

            while (next && next?.id !== id.toString()) {
                next?.classList.toggle('DriverPool-Drivers-List-Selected');
                const nextId = parseInt(next.id);
                if (temp.includes(nextId)) temp.splice(temp.indexOf(nextId), 1);
                else temp.push(nextId);
                next =
                    index > firstElementsIndex
                        ? (next.nextSibling as HTMLElement)
                        : (next.previousElementSibling as HTMLElement);
            }
            if (temp.includes(id)) temp.splice(temp.indexOf(id), 1);
            else temp.push(id);
            setFirstElement(id);
            setFirstElementsIndex(index);
        } else {
            firstElement !== id ? setFirstElement(id) : setFirstElement(-1);
            firstElementsIndex !== index ? setFirstElementsIndex(index) : setFirstElementsIndex(-1);
            if (temp.includes(id)) temp.splice(temp.indexOf(id), 1);
            else temp.push(id);
        }

        if (isListTypeSelected) setSelectedDriversToMove(temp);
        else setAvailableDriversToMove(temp);
    };

    const moveElement = (
        moveTo: string,
        itemsToMove: (number | undefined)[] | undefined,
        availableDriversList: (number | null | undefined)[] | undefined,
        selectedDriversList: (number | null | undefined)[] | undefined,
    ) => {
        if (itemsToMove && availableDriversList && selectedDriversList) {
            if (moveTo === 'right') {
                for (const item of itemsToMove) {
                    if (item) {
                        selectedDriversList.push(item);
                        availableDriversList.splice(availableDriversList.indexOf(item), 1);
                    }
                }
            }
            if (moveTo === 'left') {
                for (const item of itemsToMove) {
                    if (item) {
                        availableDriversList.push(item);
                        selectedDriversList.splice(selectedDriversList.indexOf(item), 1);
                    }
                }
            }
            for (const item of itemsToMove) {
                if (item)
                    document.getElementById(item.toString())?.classList.remove('DriverPool-Drivers-List-Selected');
            }
            setSelectedDriversListState(selectedDriversList);
            setAvailableDriversListState(availableDriversList);
            setFirstElement(-1);
            setFirstElementsIndex(-1);
        }
    };

    const reset = (): void => {
        setSelectedDriverSearchPhrase('');
        setAvailableDriverSearchPhrase('');
        setAvailableDriversToMove([]);
        setSelectedDriversToMove([]);
        setFirstElement(-1);
        setFirstElementsIndex(-1);
    };

    const onCancel = (): void => {
        onClickBack();
        setDriverListReset(true);
        reset();
    };

    const onSave = (): void => {
        onClickSave(selectedDriversListState);
        reset();
    };

    return (
        <Modal show={show} onHide={onCancel} dialogClassName="DriverPoolModal-Container">
            {/* <ToastContainer /> */}
            <Modal.Header className="DriverPoolModal-HeaderContainer">
                <Modal.Title className="DriverPoolModal-TitleContainer">
                    <button className="material-icons DriverPoolModal-CloseButton" onClick={onCancel}>
                        close
                    </button>
                    <div className="DriverPoolModal-Title">{title}</div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="DriverPoolModal-BodyContainer">
                <React.Fragment>
                    <span className="DriverPoolModal-TabsContainer">
                        <div className="DriverPoolModal-ActiveTab">Available Drivers</div>
                        <div className="DriverPoolModal-ActiveTab-Selected">Selected Drivers</div>
                    </span>
                    <div className="DriverPoolModal-MainContainer">
                        <div className="DriverPoolModal-RightContainer">
                            <div className="DriverPool-SearchBar-Container">
                                <i className="material-icons SearchBar-Icon">search</i>
                                <input
                                    type="text"
                                    id="available-drivers-search"
                                    name="available-drivers-search"
                                    className="DriverPool-SearchBar-Input"
                                    placeholder="Search Available Drivers"
                                    onInput={() => {
                                        setAvailableDriverSearchPhrase(
                                            (document.getElementById('available-drivers-search') as HTMLInputElement)
                                                .value,
                                        );
                                    }}
                                />
                            </div>
                            <div className="select-box mt-2" id="available-drivers-list">
                                {filteredAvailableDrivers?.map((item, index) => (
                                    <AddDriversToPoolOption
                                        key={index}
                                        index={index}
                                        driverId={item?.driverId?.toString()}
                                        driverName={item?.name}
                                        jobName={item?.jobName}
                                        isListTypeSelected={false}
                                        isSelected={
                                            item?.driverId ? availableDriversToMove.includes(item?.driverId) : false
                                        }
                                        onClick={(e, index, id, isListTypeSelected) =>
                                            onClickHandler(e, index, id, isListTypeSelected)
                                        }
                                    />
                                ))}
                            </div>
                        </div>

                        <div className="List-Seperator">
                            <button
                                type="button"
                                className="Driverpool-btn m-2"
                                onClick={() => {
                                    moveElement(
                                        'right',
                                        availableDriversToMove,
                                        availableDriversList,
                                        selectedDriversList,
                                    );
                                    setAvailableDriversToMove([]);
                                }}
                            >
                                <i className="material-icons Arrow-Icon">chevron_right</i>
                            </button>

                            <button
                                type="button"
                                className="Driverpool-btn m-2"
                                onClick={() => {
                                    moveElement(
                                        'left',
                                        selectedDriversToMove,
                                        availableDriversList,
                                        selectedDriversList,
                                    );
                                    setSelectedDriversToMove([]);
                                }}
                            >
                                <i className="material-icons Arrow-Icon">chevron_left</i>
                            </button>
                        </div>

                        <div className="DriverPoolModal-RightContainer">
                            <div className="DriverPool-SearchBar-Container">
                                <i className="material-icons SearchBar-Icon">search</i>
                                <input
                                    type="text"
                                    id="selected-drivers-search"
                                    name="selected-drivers-search"
                                    className="DriverPool-SearchBar-Input"
                                    placeholder="Search Selected Drivers"
                                    onInput={() => {
                                        setSelectedDriverSearchPhrase(
                                            (document.getElementById('selected-drivers-search') as HTMLInputElement)
                                                .value,
                                        );
                                    }}
                                />
                            </div>

                            <div className="form-select select-box mt-2" id="selected-drivers-list">
                                {filteredSelectedDrivers?.map((item, index) => (
                                    <AddDriversToPoolOption
                                        key={index}
                                        index={index}
                                        driverId={item?.driverId?.toString()}
                                        driverName={item?.name}
                                        jobName={item?.jobName}
                                        isListTypeSelected={true}
                                        isSelected={
                                            item?.driverId ? selectedDriversToMove.includes(item?.driverId) : false
                                        }
                                        onClick={(e, index, id, isListTypeSelected) =>
                                            onClickHandler(e, index, id, isListTypeSelected)
                                        }
                                    />
                                ))}
                            </div>
                        </div>
                    </div>
                </React.Fragment>
            </Modal.Body>
            <Modal.Footer className="DriverPoolModal-Footer">
                <CustomButton title="Cancel" isBordered onClick={onCancel}></CustomButton>
                <CustomButton title="Save" isDisabled={isDisabled} onClick={onSave}></CustomButton>
            </Modal.Footer>
        </Modal>
    );
};

export default AddDriversToPool;

